export default "__VITE_ASSET__CX8SkO4T__"